import React from "react";
import { Card, CardContent, Grid } from "@mui/material";
import { styled } from "@mui/system";
import farmIcon from "../../assets/Icon/MyFarmsIcon.png";
import CustomButton from "./CustomButton";

const StyledCard = styled(Card)({
  height: "100px",
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  marginTop: "20px",
  // padding: "0 10px",
  paddingLeft: "-10px",
  border: "0.5px solid #DF9B92",
  width: "100%",
});

const StyledCardContent = styled(CardContent)({
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  width: "100%",
  padding: 0,
  marginTop: "20px",
});

const StyledIcon = styled("img")({
  height: "70px",
  width: "70px",
  marginRight: "20px",
  marginTop: "15px",
  marginLeft: "10px",
});

const ButtonContainer = styled("div")({
  marginLeft: "auto",
});

export default function FarmViewCard({ onClick, farmerStatus, t }) {
  const isAddFarmComplete = farmerStatus.stages?.find(
    (s) => s.stage_name === "Add Farm"
  )?.complete;

  return (
    <StyledCard>
      <StyledCardContent>
        {isAddFarmComplete ? (
          <Grid container>
            <Grid item xs={5}>
              <StyledIcon src={farmIcon} alt="Farm Icon" />
            </Grid>
            <Grid item xs={6} sx={{ marginTop: "10px" }}>
              <ButtonContainer>
                <CustomButton
                  onClick={() => (window.href = "/farmer/farms")}
                  hideIcon={true}
                >
                  {t("View Farm")}
                </CustomButton>
              </ButtonContainer>
            </Grid>
          </Grid>
        ) : (
          <Grid container>
            <Grid item xs={5}>
              <StyledIcon src={farmIcon} alt="Farm Icon" />
            </Grid>
            <Grid item xs={6} sx={{ marginTop: "10px" }}>
              <ButtonContainer>
                <CustomButton onClick={onClick} hideIcon={true}>
                  {t("Add Farm")}
                </CustomButton>
              </ButtonContainer>
            </Grid>
          </Grid>
        )}
      </StyledCardContent>
    </StyledCard>
  );
}
